module.exports = __webpack_public_path__ + "img/takeOutAward.37d350df.svg";